import React from 'react';

import type { LineItemEntity } from '../../../../../../types';
import { getBufferChangeText } from './getBufferChangeText';

type Props = {
  value?: number | null;
  isShown: boolean;
  entities?: LineItemEntity[];
  showIndividualChanges?: boolean;
};

const BufferRow = ({ value, isShown, entities, showIndividualChanges }: Props): React.JSX.Element => {
  if (!isShown) return <></>;

  if (showIndividualChanges && entities) {
    const selectedEntities = entities.filter((entity) => entity.isSelected);

    if (selectedEntities.length === 0) {
      return <div>-</div>;
    }

    return (
      <div>
        {selectedEntities.map((entity) => (
          <div key={entity.id}>
            • {entity.name}: {getBufferChangeText(entity)}
          </div>
        ))}
      </div>
    );
  }

  return <div>{value === null ? '-' : <span>{value}%</span>}</div>;
};

export default BufferRow;
